import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { NetworkListCustomerCell } from './network-list-customer';
import { NetworkListCustomerHeader } from './network-list-customer.header';

export const NetworkListCustomerColumn: IdentifiedColumnDef<
  GatewayNetworkModel,
  GatewayNetworkModel['customer']
> = {
  enableSorting: false,
  header: NetworkListCustomerHeader,
  cell: NetworkListCustomerCell,
};
